import React, { useEffect, useState } from 'react';
import { Card, Row, Col, message } from 'antd';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
import api from '../../services/api';

export default function RelatoriosCrechePage() {
  const [ocupacao, setOcupacao] = useState([]);
  const [assiduidade, setAssiduidade] = useState([]);
  const [inadimplencia, setInadimplencia] = useState([]);

  useEffect(() => {
    async function carregar() {
      try {
        const [o, a, i] = await Promise.all([
          api.get('/creche/relatorios/ocupacao'),
          api.get('/creche/relatorios/assiduidade'),
          api.get('/creche/relatorios/inadimplencia'),
        ]);
        setOcupacao(o.data || []);
        setAssiduidade(a.data || []);
        setInadimplencia(i.data || []);
      } catch (e) {
        message.error('Erro ao carregar relatórios');
      }
    }
    carregar();
  }, []);

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <Row gutter={16}>
        <Col span={24}>
          <Card title="Ocupação por Grupo" className="mb-6">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={ocupacao}>
                <XAxis dataKey="grupo" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="ocupacao" fill="#1890ff" />
              </BarChart>
            </ResponsiveContainer>
          </Card>
        </Col>

        <Col span={24}>
          <Card title="Assiduidade (últimos 30 dias)" className="mb-6">
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={assiduidade}>
                <XAxis dataKey="data" />
                <YAxis />
                <Tooltip />
                <Line type="monotone" dataKey="percentual" stroke="#52c41a" />
              </LineChart>
            </ResponsiveContainer>
          </Card>
        </Col>

        <Col span={24}>
          <Card title="Inadimplência">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={inadimplencia}>
                <XAxis dataKey="grupo" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="pendentes" fill="#ff4d4f" />
              </BarChart>
            </ResponsiveContainer>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
